import { runQuery } from 'src/api/apollo/runQuery';
import { GET_ACTIVITIES } from 'src/api/graphql/queries/activities.gql';

export const getActivitiesByCompanyId = async (
	companyId,
	{ first = 50, filters = {} } = {},
) => {
	const { data } = await runQuery({
		query: GET_ACTIVITIES,
		variables: {
			first,
			filters: {
				company: { eq: [Number(companyId)] },
				...filters,
			},
		},
		fetchPolicy: 'network-only',
	});

	const activities = data?.activities?.edges?.map(({ node }) => node) ?? [];

	return {
		activities: activities.reverse(),
		facets: data?.activities?.facets ?? { creators: [], types: [] },
	};
};
